var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('treeselect',_vm._b({attrs:{"value":_vm.treeselectValue,"options":_vm.options},on:{"input":function($event){return _vm.$emit('input', $event)}}},'treeselect',_vm.treeselectProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }